import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  progress: 0,
};

const uploadSlice = createSlice({
  name: 'upload',
  initialState,
  reducers: {
    setUploadProgress: (state, action) => {
      state.progress = action.payload;
    },
    clearUploadProgress: (state) => {
      state.progress = 0;
    },
  },
});

export const { setUploadProgress, clearUploadProgress } = uploadSlice.actions;
export default uploadSlice.reducer;